<template>
	<div class="install-app"></div>
</template>

<script>
export default {
	data () {
		return {
			deferredPrompt: null,
			modalBox: {
				open: false
			}
		}
	},
	watch: {
		deferredPrompt (value) {
			if (value && value.isTrusted) {
				this.$appModal.show({
					icon: true,
					buttons: 2,
					title: this.$t(`base.install.title`),
					message: this.$t(`base.install.message`),
					buttonsLabels: {
						ok: this.$t(`base.install.buttons.install`),
						cancel: this.$t(`base.install.buttons.later`)
					},
					onOK: () => {
						this.onInstall()
					}
				})
			}
		}
	},
	methods: {
		onInstall () {
			this.addToHomeScreen()
		},
		onModalBoxClose () {
			this.modalBox.open = false
		},
		addToHomeScreen () {
			this.deferredPrompt.prompt()
			this.deferredPrompt.userChoice
				.then(result => {
					this.deferredPrompt = null
				})
		}
	},
	created () {
		// window.addEventListener('beforeinstallprompt', (e) => {
		// 	e.preventDefault()
		// 	this.deferredPrompt = e
		// })
	}
}
</script>


// WEBPACK FOOTER //
// src/components/install/InstallApp.vue